import { get } from '../http';

export default function getStripeSubscriptionStatus() {
  const url = '/rest/v1/billing/status';
  const headers = new Headers({
    'Content-Type': 'application/json',
  });
  return get({ url, headers });
}
